import React from "react";
import { Box, Card, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { date } from "../../../../utils/date";
import { useNextSession } from "../../../../hooks/useNextSession";

export const NextActionWidget = () => {
    const navigate = useNavigate();
    const { nextSession, fetching, error } = useNextSession();

    if (fetching || error || !nextSession) {
        return null;
    }

    const isStoryPrepared = nextSession.isStoryPrepared;
    const actionText = isStoryPrepared ? "Deliver session \u203A" : "Open preparation \u203A";
    const route = isStoryPrepared ? `/deliver-session/${nextSession.id}` : `/prepare-session/${nextSession.id}`;

    return (
        <Box mb={4}>
            <Typography variant="overline" color="primary" sx={{ fontWeight: "bold", letterSpacing: 1.2 }}>
                NEXT ACTION
            </Typography>
            <Card sx={{ p: 3, mt: 1 }}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} md={8}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 0.5 }}>
                            {nextSession.Programme?.name}
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            {date(nextSession.date)} — Story: {nextSession.MappedStory.Story.storyName}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ textAlign: { md: "right", xs: "left" }, mt: { xs: 2, md: 0 } }}>
                        <Button variant="contained" color="primary" onClick={() => navigate(route)} size="large">
                            {actionText}
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </Box>
    );
};
